/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
//import translation function for language translation
import { useTranslation } from "react-i18next";
/* Importing react select */
import Select from "react-select";
//import context
import { GlobalProvider } from "context/GlobalContext";
/*import url and gateway methods */
import { getData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

const BudgetFilter = () => {
  const token = localStorage.getItem("token"); // token
  const { t } = useTranslation(); //for translation
  const todayValue = new Date().toISOString().split("T")[0];

  const {
    setReloadSalesOrderList,
    setSearchSalesOrderDate,
    setSearchSalesOrderDateType,
    setSearchSalesOrderClients,
    setSearchSalesOrderBudgetStatus,
    setSearchSalesOrderDiscount,
    isBudgetLoading,
  } = useContext(GlobalProvider);

  const [selectedChecked, setSelectedChecked] = useState("");
  const [budgetStatusList, setBudgetStatusList] = useState([]);
  const [fromDate, setFromDate] = useState(todayValue);
  const [toDate, setToDate] = useState(todayValue);
  const [selectedDate, setSelectedDate] = useState(todayValue);
  const [clientList, setClientList] = useState([]);
  const [dateSelectedValue, setDateSelectedValue] = useState(null);
  const [selectedClientValue, setSelectedClientValue] = useState(null);
  const [selectedClientIds, setSelectedClientIds] = useState([]);
  const [budgetStatusValue, setBudgetStatusValue] = useState(null);
  const [selectedBudgetStatus, setSelectedBudgetStatus] = useState([]);
  const [discountRate, setDiscountRate] = useState(0);
  const [dateWarning, setDateWarning] = useState(false);
  const [noFilterWarning, setNoFilterWarning] = useState(false);

  // Get budget status options
  const getBudgetStatusOptions = async () => {
    try {
      let requestUrl =
        url.API_BASEURL + url.API_GET_BUDGET_STATUS_LIST + `?token=${token}`;
      const response = await getData(requestUrl);
      if (response.status) {
        setBudgetStatusList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  /* function to get all client list */
  const getALlClientList = async () => {
    try {
      let clientRequestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_USER +
        `?token=${token}&isselect=${true}&slug=client&limit=0`;
      let benificiaryRequestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_USER +
        `?token=${token}&isselect=${true}&slug=beneficiary&limit=0`;
      const clientResponse = await getData(clientRequestUrl);
      const beneficiaryResponse = await getData(benificiaryRequestUrl);
      if (clientResponse.status && beneficiaryResponse.status) {
        setClientList([...clientResponse.data, ...beneficiaryResponse.data]);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  // Date type options
  const dateTypeOptions = [
    { label: t("Invoice Date"), value: "Invoice" },
    { label: t("Created date"), value: "Created" },
  ];

  // Radio handler
  const radioCheckHandler = (event) => {
    setSelectedChecked(event.target.value);
    setDateWarning(false);
    setNoFilterWarning(false);
  };

  // Client selection handler
  const clientSelectionHandler = (val) => {
    if (val) {
      setSelectedClientValue(val);
      setSelectedClientIds(val.map((client) => client.value));
    } else {
      setSelectedClientValue(null);
      setSelectedClientIds([]);
    }
    setNoFilterWarning(false);
  };

  // Budget status selection handler
  const budgetStatusSelectionHandler = (val) => {
    if (val) {
      setBudgetStatusValue(val);
      setSelectedBudgetStatus(val.map((item) => item.value));
    } else {
      setBudgetStatusValue(null);
      setSelectedBudgetStatus([]);
    }
    setNoFilterWarning(false);
  };

  // Search handler
  const searchHandler = () => {
    const hasFilter =
      selectedChecked !== "" ||
      selectedClientIds.length > 0 ||
      selectedBudgetStatus.length > 0 ||
      discountRate != 0;

    if (!hasFilter) {
      setNoFilterWarning(true);
      return;
    }
    setNoFilterWarning(false);

    /*===== switch statement for date input radio start ======*/
    switch (selectedChecked) {
      case "daterange":
        if (fromDate < toDate) {
          setSearchSalesOrderDate(fromDate + "," + toDate);
        } else {
          setDateWarning(true);
          return;
        }
        break;
      case "todayradio":
        setSearchSalesOrderDate(todayValue);
        break;
      case "salesdate":
        setSearchSalesOrderDate(selectedDate);
        break;
      default:
        setSearchSalesOrderDate("");
        break;
    }
    /*===== switch statement for date input radio end ======*/

    dateSelectedValue != null &&
      setSearchSalesOrderDateType(dateSelectedValue?.value);
    selectedClientIds.length > 0
      ? setSearchSalesOrderClients(selectedClientIds)
      : setSearchSalesOrderClients([]);
    selectedBudgetStatus.length > 0
      ? setSearchSalesOrderBudgetStatus(selectedBudgetStatus)
      : setSearchSalesOrderBudgetStatus([]);
    discountRate != 0 && setSearchSalesOrderDiscount(discountRate);
  };

  // Reset handler
  const resetHandler = () => {
    setSelectedChecked("");
    setFromDate(todayValue);
    setToDate(todayValue);
    setSelectedDate(todayValue);
    setDateSelectedValue({ label: "Invoice date", value: "Invoice" });
    setSelectedClientValue(null);
    setSelectedClientIds([]);
    setBudgetStatusValue(null);
    setSelectedBudgetStatus([]);
    setDiscountRate(0);
    setDateWarning(false);
    setNoFilterWarning(false);
    setSearchSalesOrderDate("");
    setSearchSalesOrderDateType(null);
    setSearchSalesOrderClients([]);
    setSearchSalesOrderBudgetStatus([]);
    setSearchSalesOrderDiscount(0);
    setReloadSalesOrderList(true);
  };

  useEffect(() => {
    getALlClientList();
    getBudgetStatusOptions();
    setDateSelectedValue({ label: "Invoice date", value: "Invoice" });
  }, []);

  return (
    <div className="collapse mt-3" id="filterbudgetCollapse">
      <div className="p-3 bg-gray-200">
        <form onSubmit={(e) => e.preventDefault()}>

          {/* ===== BLOCK 1: Filter by Date ===== */}
          <div className="border rounded p-3 mb-3 bg-white">
            <p className="text-muted small fw-semibold text-uppercase mb-2 d-flex align-items-center gap-1">
              <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>calendar_month</span>
              {t("Filter by Date")}
            </p>
            <div className="row g-3 align-items-start">

              {/* a) Date Range */}
              <div className="col-lg-5">
                <div
                  className={`border rounded p-2 h-100 ${selectedChecked === "daterange" ? "border-primary bg-primary bg-opacity-10" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => { setSelectedChecked("daterange"); setDateWarning(false); setNoFilterWarning(false); }}
                >
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <input
                      className="form-check-input mt-0"
                      type="radio"
                      name="budgetDateGroup"
                      id="budgetDateRange"
                      value="daterange"
                      checked={selectedChecked === "daterange"}
                      onChange={radioCheckHandler}
                    />
                    <label className="form-check-label fw-medium mb-0" htmlFor="budgetDateRange" style={{ cursor: "pointer" }}>
                      {t("Range")}
                    </label>
                  </div>
                  <div className="d-sm-flex gap-2">
                    <input
                      type="date"
                      className="form-control form-control-sm bg-white"
                      value={fromDate}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => { setFromDate(e.target.value); setDateWarning(false); setSelectedChecked("daterange"); setNoFilterWarning(false); }}
                    />
                    <input
                      type="date"
                      className="form-control form-control-sm bg-white mt-2 mt-sm-0"
                      value={toDate}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => { setToDate(e.target.value); setDateWarning(false); setSelectedChecked("daterange"); setNoFilterWarning(false); }}
                    />
                  </div>
                  {dateWarning && (
                    <p className="d-flex align-items-center gap-1 text-danger small mb-0 mt-1">
                      <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>warning</span>
                      {t("End date should be greater than start date")}!
                    </p>
                  )}
                </div>
              </div>

              {/* b) Today */}
              <div className="col-lg-2">
                <div
                  className={`border rounded p-2 h-100 d-flex align-items-center gap-2 ${selectedChecked === "todayradio" ? "border-primary bg-primary bg-opacity-10" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => { setSelectedChecked("todayradio"); setDateWarning(false); setNoFilterWarning(false); }}
                >
                  <input
                    className="form-check-input mt-0"
                    type="radio"
                    name="budgetDateGroup"
                    id="budgetToday"
                    value="todayradio"
                    checked={selectedChecked === "todayradio"}
                    onChange={radioCheckHandler}
                  />
                  <label className="form-check-label fw-medium mb-0" htmlFor="budgetToday" style={{ cursor: "pointer" }}>
                    <span className="material-symbols-outlined align-middle me-1" style={{ fontSize: "16px" }}>today</span>
                    {t("Today")}
                  </label>
                </div>
              </div>

              {/* c) Specific Date */}
              <div className="col-lg-2">
                <div
                  className={`border rounded p-2 h-100 ${selectedChecked === "salesdate" ? "border-primary bg-primary bg-opacity-10" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => { setSelectedChecked("salesdate"); setDateWarning(false); setNoFilterWarning(false); }}
                >
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <input
                      className="form-check-input mt-0"
                      type="radio"
                      name="budgetDateGroup"
                      id="budgetSpecificDate"
                      value="salesdate"
                      checked={selectedChecked === "salesdate"}
                      onChange={radioCheckHandler}
                    />
                    <label className="form-check-label fw-medium mb-0" htmlFor="budgetSpecificDate" style={{ cursor: "pointer" }}>
                      {t("Date")}
                    </label>
                  </div>
                  <input
                    type="date"
                    className="form-control form-control-sm bg-white"
                    value={selectedDate}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => { setSelectedDate(e.target.value); setSelectedChecked("salesdate"); setNoFilterWarning(false); }}
                  />
                </div>
              </div>

              {/* d) Date Type */}
              <div className="col-lg-3">
                <label className="form-label small text-muted mb-1">{t("Date Type")}</label>
                <Select
                  placeholder={t("Select date type")}
                  options={dateTypeOptions}
                  value={dateSelectedValue}
                  onChange={(val) => setDateSelectedValue(val)}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>

            </div>
          </div>
          {/* ===== END BLOCK 1 ===== */}

          {/* ===== BLOCK 2: Filter by Client, Status & Discount ===== */}
          <div className="border rounded p-3 mb-3 bg-white">
            <p className="text-muted small fw-semibold text-uppercase mb-2 d-flex align-items-center gap-1">
              <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>filter_list</span>
              {t("Filter by Client & Status")}
            </p>
            <div className="row g-3">

              {/* Client */}
              <div className="col-lg-4">
                <label className="form-label small text-muted mb-1">{t("Client")}</label>
                <Select
                  className="nosearch_select"
                  placeholder={t("Select clients")}
                  isMulti
                  options={clientList}
                  value={selectedClientValue}
                  onChange={(val) => clientSelectionHandler(val)}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>

              {/* Budget Status */}
              <div className="col-lg-4">
                <label className="form-label small text-muted mb-1">{t("Budget Status")}</label>
                <Select
                  isMulti
                  placeholder={t("Select Budget Status")}
                  options={budgetStatusList}
                  value={budgetStatusValue}
                  onChange={(val) => budgetStatusSelectionHandler(val)}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>

              {/* Discount */}
              <div className="col-lg-4">
                <label className="form-label small text-muted mb-1">{t("Discount")} %</label>
                <input
                  type="number"
                  className="form-control bg-white"
                  placeholder={t("e.g. 10")}
                  value={discountRate}
                  onChange={(e) => { setDiscountRate(e.target.value); setNoFilterWarning(false); }}
                />
              </div>

            </div>
          </div>
          {/* ===== END BLOCK 2 ===== */}

          {/* ===== Actions ===== */}
          {noFilterWarning && (
            <p className="d-flex align-items-center gap-1 text-danger small mb-2 justify-content-end">
              <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>warning</span>
              {t("Please select at least 1 filter parameter before applying.")}
            </p>
          )}
          <div className="d-flex gap-3 align-items-center justify-content-end">
            <Link
              to="#"
              className="d-flex gap-1 align-items-center text-secondary"
              onClick={resetHandler}
            >
              <span className="material-symbols-outlined icon-md">sync</span>
              <span className="fw-medium">{t("Reset")}</span>
            </Link>
            <button
              type="submit"
              className="btn btn-primary px-4 d-flex align-items-center gap-2"
              onClick={searchHandler}
              disabled={isBudgetLoading}
            >
              {isBudgetLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  />
                  {t("Loading...")}
                </>
              ) : (
                <>
                  <span className="material-symbols-outlined align-middle" style={{ fontSize: "18px" }}>search</span>
                  {t("Apply Filter")}
                </>
              )}
            </button>
          </div>
          {/* ===== End Actions ===== */}

        </form>
      </div>
    </div>
  );
};
export default BudgetFilter;
